exports = module.exports = require("../../../../vue-ssr-factory/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html body {\n  min-width: auto !important;\n}\n", ""]);

